import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__tooltip';
export class Tooltip {
    static init($root = $('body')) {
        const $tooltipElement = $root.find(ELEMENT_SELECTOR);
        if (!$tooltipElement.length) {
            return;
        }
        $('.js__tooltip').popup();
    }
}
